import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import DeleteIcon from '@material-ui/icons/Delete';
import { TreeItem, TreeView } from '@material-ui/lab';
import { groupBy } from 'utilities/arrays';
import { ArrowDropDown, ArrowRight } from '@material-ui/icons';
import { TextField, IconButton, Typography } from '@material-ui/core';
import {
  setSelectedShapes,
  setSelectedShapeId,
  setNewShapeName,
} from 'store/actions';

const NewShapeDetail = ({
  classes,
  newShapeName,
  selectedShapes,
  setSelectedShapes,
  setSelectedShapeId,
  setNewShapeName,
}) => {
  // == Constants ===========================================

  const noSelectedShapes = !selectedShapes || selectedShapes.length === 0;

  // == useState ============================================

  const [geoLevelMap, setGeoLevelMap] = useState(null);
  const [expanded, setExpanded] = useState([]);

  // == useEffect ===========================================

  useEffect(() => {
    var geoLevelMap = groupBy(selectedShapes, (shape) => shape.level);
    setGeoLevelMap(geoLevelMap);
    setExpanded(Array.from(geoLevelMap.keys()));
  }, [selectedShapes]);

  // == Event Handlers ======================================

  const onDeleteGeoGroup = (geoGroup) => {
    setSelectedShapes(selectedShapes.filter((s) => s.level !== geoGroup));
    setSelectedShapeId(null);
  };

  const onDeleteShape = (shape) => {
    setSelectedShapes(selectedShapes.filter((s) => s !== shape));
    setSelectedShapeId(null);
  };

  const onShapeNameChanged = (e) => {
    setNewShapeName(e.target?.value ?? '');
  };

  const handleToggle = (event, nodeIds) => {
    setExpanded(nodeIds);
  };

  // == Components ========================================

  const renderTree = (geoLevelGroup) => (
    <TreeItem
      key={geoLevelGroup[0]}
      nodeId={geoLevelGroup[0]}
      label={
        <div className={classes.labelRoot}>
          <Typography variant='subtitle2' className={classes.labelText}>
            {geoLevelGroup[0]} ({geoLevelGroup[1].length})
          </Typography>
          {geoLevelGroup[1].length > 1 && (
            <IconButton
              title='Delete Geo'
              size='small'
              onClick={() => onDeleteGeoGroup(geoLevelGroup[0])}
            >
              <DeleteIcon />
            </IconButton>
          )}
        </div>
      }
    >
      {geoLevelGroup[1].map((shape) => (
        <TreeItem
          key={shape.id}
          nodeId={shape.id}
          label={
            <div className={classes.labelRoot}>
              <Typography variant='body2' className={classes.labelText}>
                {shape.id}
              </Typography>
              <IconButton
                title='Delete Shape'
                size='small'
                onClick={() => onDeleteShape(shape)}
              >
                <DeleteIcon />
              </IconButton>
            </div>
          }
        ></TreeItem>
      ))}
    </TreeItem>
  );

  return (
    <div className={classes.container}>
      <TextField
        label='Shape name'
        margin='none'
        placeholder='Enter a shape name...'
        value={newShapeName}
        size='small'
        fullWidth
        onChange={onShapeNameChanged}
        InputLabelProps={{
          shrink: true,
        }}
      />

      {noSelectedShapes ? (
        <div className={classes.noShapesDiv}>
          <Typography className={classes.noShapesText} variant='body2'>
            Select a shape from the map
          </Typography>
        </div>
      ) : (
        <div>
          <TreeView
            defaultCollapseIcon={<ArrowDropDown />}
            defaultExpandIcon={<ArrowRight />}
            onNodeToggle={handleToggle}
            expanded={expanded}
          >
            {geoLevelMap && geoLevelMap.size > 0 ? (
              Array.from(geoLevelMap).map((geoLevelGroup) =>
                renderTree(geoLevelGroup)
              )
            ) : (
              <></>
            )}
          </TreeView>
        </div>
      )}
    </div>
  );
};

// == Styles =============================================

const styles = (theme) => ({
  container: {
    margin: '4px',
  },
  // Treeview label
  labelRoot: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0.5, 0),
  },
  labelText: {
    flexGrow: 1,
  },
  noShapesDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 42,
    margin: '4px 8px',
  },
  noShapesText: {
    fontStyle: 'italic',
    color: '#a7a9ac',
    fontSize: '.9rem',
  },
});

// == Connect =============================================

const mapStateToProps = ({ assumptionGroupsState }) => ({
  selectedGroup: assumptionGroupsState.selectedGroup,
  selectedShapes: assumptionGroupsState.selectedShapes,
  newShapeName: assumptionGroupsState.newShapeName,
});

const mapDispatchToProps = {
  setNewShapeName,
  setSelectedShapes,
  setSelectedShapeId,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(NewShapeDetail);
